import { Box, Typography } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled(Box)`
  ${({ theme,width }) => `
    width: ${width ? "80%" : "100%"};
    flex-direction : ${width ? "row" : "column"}
    margin: auto;
    padding: ${width ? "4% 7%" : "10px 20px"};
    margin-top: 14%;
    // margin-left: 10%;
    display: flex;
    justify-content: ${width ? "flex-start" : "center"};
    border-top: 1px solid ${theme.palette.backgrounds.gray};
    border-bottom: 1px solid ${theme.palette.backgrounds.gray};
    
    ${theme.breakpoints.down('lg')} {
      img {
        width: 30px;
      }
    }
  `}
`;

export const Placeholder = styled(Box)`
  ${({ theme,width }) => `
    width: ${width ? "80%" : "100%"};
    flex-direction : ${width ? "row" : "column"}
    margin: auto;
    padding: ${width ? "4% 7%" : "10px 20px"};
    margin-top: 14%;
    margin-left: 0%;
    display: flex;
    justify-content: ${width ? "flex-start" : "flex-start"};
    border-top: 1px solid ${theme.palette.backgrounds.gray};
    border-bottom: 1px solid ${theme.palette.backgrounds.gray};
    
    ${theme.breakpoints.down('lg')} {
      img {
        width: 30px;
      }
    }
  `}
`;

// justify-content: center;
// margin: auto 0;
// padding: 4% 0;
// width: 100%;

export const Image = styled.img`
  max-height: 43px;
  max-width: 43px;
  border-radius: 50%;
  display: block;
  margin: auto 0;
  margin-right: 7%;
`;

export const NameDiv = styled(Box)`
  ${({ theme, width }) => `
    display: ${width ? 'block' : 'none'};
    @media (max-width: 960px){
      display: none;
    }
  `}
`;

export const Name = styled(Typography)`
  ${({ theme }) => `
    color: ${theme.palette.dark.main};
    font-weight: 700;
    ${theme.mixins.makeResponsive({ theme, fontSize: 18 })};
    text-transform: capitalize;
  `}
`;

export const Role = styled(Typography)`
  ${({ theme }) => `
    color: ${theme.palette.dark.main};
    font-weight: 400;
    ${theme.mixins.makeResponsive({ theme, fontSize: 14 })};
  `}
`;
